<template>
  <p class="BodyContentNote">
    <slot />
  </p>
</template>

<style scoped>
.BodyContentNote {
  background-color: #FFFBEB;
  padding: var(--spacing-7) var(--spacing-8);
  border-radius: 10px;
  font-size: var(--font-size-3);
  color: var(--text-color-dark);
}
</style>
